import { render, staticRenderFns } from "./MultipleToggle.vue?vue&type=template&id=36d617e2"
import script from "./MultipleToggle.vue?vue&type=script&lang=js"
export * from "./MultipleToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports